import { render, staticRenderFns } from "./CLabel.vue?vue&type=template&id=1af419ca"
import script from "./CLabel.vue?vue&type=script&lang=ts"
export * from "./CLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports